import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics-service/google-analytics.service';

@Component({
  selector: 'app-panther-lake-onboarding',
  templateUrl: './panther-lake-onboarding.component.html',
  styleUrls: ['./panther-lake-onboarding.component.scss'],
})
export class PantherLakeOnboardingComponent implements OnInit {
  setFontIntelDisplayOne: boolean;
  ptlOnboardingText: any;
  ptlType: string;
  language: string;
  isRTL: boolean;
  isEnglish: boolean;
  ptlArrow: string;
  ptl12xe: boolean = false;

  constructor(
    private libraryService: LibraryV2DataService,
    private qrCodeService: QrCodeService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if(this.qrCodeService.isPantherLakeStd) {
      this.ptlType = GlobalConstants.PANTHER_LAKE;
    } else if(this.qrCodeService.isPantherLake12Xe) {
      this.ptlType = GlobalConstants.PANTHER_LAKE_12XE;
      this.ptl12xe = true;
    }
    this.ptlOnboardingText =
      this.libraryService.getStaticText('tr_OnboardingText');
    if (this.ptlOnboardingText?.tr_tabs) {
      this.ptlOnboardingText.tr_tabs = this.ptlOnboardingText.tr_tabs.map(
        (tab, index) => ({
          ...tab,
          link: GlobalConstants.PTL_NAVIGATION_TABS[index],
        })
      );
    }
    
    const qrData = this.qrCodeService.getQrData();
    this.language = qrData.Language;
    this.isRTL = this.language === "ar-sa" || this.language === "he";
    this.isEnglish = this.language === "en-us";
    if(!this.isRTL){
      this.ptlArrow = this.ptl12xe ? this.ptlOnboardingText.ptl_12xe_right_arrow_icon : this.ptlOnboardingText?.ptl_right_arrow_icon
    } else{
      this.ptlArrow = this.ptl12xe ? GlobalConstants.LEFT_CHEVERON_WHITE : GlobalConstants.LEFT_CHEVERON_BLACK;     
    }

    this.setFontIntelDisplayOne = this.qrCodeService?.setenusLang();
  }

  routeToPage(tab) {
    // Temporary code for promos tab, most likely to be remmove after discussion with portinos.
    if (tab.link == 'promos') return;

      this.router.navigate([], {
        queryParams: { activeTab: tab.link },
      });
      if(tab.link == 'specs'){
        let allSpecsText = this.qrCodeService.isChromeBook ? GlobalConstants.VIEW_MORE_TEXT: GlobalConstants.VIEW_ALL_SPECS_TEXT;
        this.googleAnalyticsService.sendGtag(GlobalConstants.VIEW_ALL_SPECS_TEXT, { event_category: allSpecsText, event_label: '', 'view_all_specs': 1 });
      }
      if(tab.link == 'overview'){
      this.googleAnalyticsService.sendGtag(GlobalConstants.OVERVIEW_TEXT, { event_category: GlobalConstants.OVERVIEW_TEXT, event_label: '', 'overview': 1 });
    }
      if(tab.link == 'compare'){
      this.googleAnalyticsService.sendGtag( GlobalConstants.COMPARE_DEVICE, { event_category: GlobalConstants.COMPARE_DEVICE, event_label: GlobalConstants.COMPARE_DEVICE, 'compare_device': 1 });
    }
  }
}
